import ExpandedForm from "../../components/ClassOne/Mathematics/ExpandedForm";
import PlaceValue from "../../components/ClassOne/Mathematics/PlaceValue";
import ShortForm from "../../components/ClassOne/Mathematics/ShortForm";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}



const topics: MenuItem[] = [
    { url: "/class-one/mathematics/number-math/short-form", title: "Short Form", component: ShortForm },
    { url: "/class-one/mathematics/number-math/place-value", title: "Place Value", component: PlaceValue },
    { url: "/class-one/mathematics/number-math/expanded-form", title: "Expanded Form", component: ExpandedForm },
];

export default topics;